import { createSlice } from "@reduxjs/toolkit";
import {productApi} from "../../configurator/services/productApi";
import {setupSkuExceptionsAndSelections} from "../exceptions/skuExceptionsSlice";
import {
    clearDisabledFields,
    setDisabledFields,
    setDisabledModules, updateDisabledElementFields,
    updateDisabledFields,
    updatePatternSideExceptions
} from "../exceptions/disabledFieldsSlice";
import {
    compareSummaryCatWithPartNumber,
    expandCategoriesChanged,
    expandProductsChanged,
    generateCatalogNumber,
    manageConfiguratorState, setDisplayElementSummary,
    setDisplayPatternSummary,
    setDisplaySummary, setElementSaveShouldUpdate, setElementsDisplayingOptions,
    setErrorFields,
    setErrors, setHasElements,
    setIsPattern, setShapeElementsMatchSelections,
 setQuickshipInt,
    shouldUpdateModulesSet,
} from "../configuratorStateSlice";
import {
    checkForEmptyRequiredSelection, displayGeneratedShapeElements,
    productSelectionChanged,
    selectionsSelectionsClear,
    separateProductAttributes, setAttributeSelectionsFromSelections, setEmptyPerModuleSelections,
    setNextSelection,
    setOptionalAttributes, setPerModuleSelections,
    setSelectionsFromPartNumber
} from "./productSelectionsSlice";
import modulesApi from "../../configurator/services/modulesApi";
import {getElementSummary, getPatternSummary, getSummary} from "../summarySlice";
import quoteItemApi from "../../configurator/services/quoteItemApi";
import {
    categoryIdSet, setAgencyParams,
    setCurrency, setLanguage,
    setLineNumber, setLineNumberForNewQuoteItem, setPriceBook,
    setProductIdDetails,
    setProjectName,
    setProjectType,
    setQuantity, setQuoteId, setQuoteItemId
} from "../details/projectDetailsSlice";
import { setPatternCode, setPatternId, setPatternsAvailable} from "../details/patternDetailsSlice";
import patternApi from "../../configurator/services/patternApi";
import {
    getPatternModules,
    setPatternSidesFromEdit,
    setSideAttributeSelectionsFromSelections, setSideModuleSelections
} from "./patternSelectionsSlice";
import store from "../store";
import {mapSectionsToSide, setElementsWithSelections, setElementsWithSelectionsFromLoad} from "./productElementsSlice";
import productElementApi from "../../configurator/services/productElementApi";

export const productDataSlice =  createSlice({
    name: 'productData',
    initialState: {
        dataLoading: 'idle',
        selectionsLoading: 'idle',
        id: "",
        family: "",
        lookup_type: "",
        name: "",
        product_attributes: [],
        sku_exceptions: [],
        product_elements: [],
        attribute_selections: [],
        quote_item_module_with_selections: [],
        modules: [],
        side_modules: [],
        side_attributes: [],
        side_attribute_selections: [],
        side_module_selections: []
    },
    reducers: {
        productDataLoading(state ,action){
            if(state.dataLoading == 'idle'){
                state.dataLoading = 'pending'
            }
        },
        productDataReceived(state, action) {
            if(state.dataLoading == 'pending'){
                state.dataLoading = 'idle';
                state.product_attributes = action.payload.product_attributes
                state.sku_exceptions = action.payload.sku_exceptions
                state.side_attributes = action.payload.side_attributes;
                state.product_elements = action.payload.product_elements;
            }
        },
        allProductDetailsUpdated(state, action){
            if( state.dataLoading == 'pending'){
                state.dataLoading = 'idle';
                state.id = action.payload.id;
                state.family = action.payload.family
                state.lookup_type = action.payload.lookup_type;
                state.name = action.payload.name;
                state.product_attributes = action.payload.product_attributes
                state.sku_exceptions = action.payload.sku_exceptions
            }
        },
        productDetailsUpdated(state, action){
            if( state.dataLoading == 'pending'){
                state.dataLoading = 'idle';
                state.id = action.payload.id;
                state.family = action.payload.family
                state.lookup_type = action.payload.lookup_type;
                state.name = action.payload.name;
            }
        },
        attributeSelectionsLoading(state, action){
            if(state.selectionsLoading == 'idle'){
                state.selectionsLoading = 'pending'
            }
        },
        attributeSelectionsSet(state, action){
            if(state.selectionsLoading == 'pending'){
                state.selectionsLoading = 'idle';
                state.attribute_selections = action.payload
            }
        },
        sideAttributeSelectionsSet(state, action){
            if(state.selectionsLoading == 'pending'){
                state.selectionsLoading = 'idle';
                state.side_attribute_selections = action.payload
            }
        },
        sideAttributesSet(state, action){
            if(state.selectionsLoading == 'pending'){
                state.selectionsLoading = 'idle';
                state.side_attributes = action.payload
            }
        },
        attributeSelectionsClear(state, action){
            state.attribute_selections = [];
            state.side_attribute_and_option_selections = [];
        },
        productSelectionsClear(state, action){
            state.product_attributes = [];
            state.modules = [];
        },
        productIdSet(state, action){
            if(state.dataLoading == 'pending'){
                state.dataLoading = 'idle'
                state.id = action.payload;
            }
        },
        modulesSet(state, action){
            if(state.dataLoading == 'pending'){
                state.dataLoading = 'idle'
                state.modules = action.payload;
            }
        },
        sideModulesSet(state, action){
            if(state.dataLoading == 'pending'){
                state.dataLoading = 'idle';
                state.side_modules = action.payload;
            }
        },
        sideModuleSelectionsSet(state, action){
            state.side_module_selections = action.payload;
        },
        quoteItemModuleAttributeSelectionsSet(state, action){
            state.quote_item_module_with_selections = action.payload;
        },
        productElementsSet(state, action){
            state.product_elements = action.payload;
        }


    }
});
export const { productDataLoading, productDataReceived, attributeSelectionsLoading, attributeSelectionsSet, attributeSelectionsClear, productDetailsUpdated, allProductDetailsUpdated, productIdSet, sideAttributeSelectionsSet, modulesSet, quoteItemModuleAttributeSelectionsSet, productSelectionsClear, sideModuleSelectionsSet, sideModulesSet, productElementsSet } = productDataSlice.actions;

export const fetchProductById = (productId) => async dispatch => {
    dispatch(setErrors([]))
    dispatch(setProductData(productId));
    dispatch(setDisplaySummary(false));
    dispatch(manageConfiguratorState());
    dispatch(productDataLoading());
    const promise = dispatch(productApi.endpoints.getProduct.initiate(productId));
    const {data: response, isSuccess} = await promise;
    if(isSuccess) {
        dispatch(setupSkuExceptionsAndSelections(response.product));
        dispatch(setDisabledFields(response.product));
        await dispatch(productDataReceived(response.product));
        dispatch(checkForAndGetElements(productId));
        dispatch(separateProductAttributes(response.product.product_attributes));
        dispatch(setNextSelection());
    }


};

export const setProductData = (productId) => (dispatch, getState) => {
    const state = getState();

    const prod = state.productsReducer.products.find((prod) => prod.id == productId);
    const family = prod ? prod.family : "";
    const lookup = prod ? prod.lookup_type : "";
    const name  = prod ? prod.name : "";
    const data = {
        id: productId,
        family: family,
        lookup_type: lookup,
        name: name
    };
    dispatch(setProductIdDetails(productId))
    dispatch(updateProductDetails(data));
}
// This is the core cycle of the app that displays the next step when available,
// and handles any changes to productSelection, as well as updates exceptions
// whenever a field is updated. The steps are as follow:
// 1) Product Select changes
// 2) Add first attribute selection
// 3) First attribute step component renders
// 4) Attribute changed
// 5) Update product selections
// 6) Update exceptions
// 7) Set next attribute selection
// 8) Render next attribute step
// 9) repeat 4-8 until optionalAttributes should display
// 10) render optionalAttributes
// 11) render perModuleAttributes
// 12) call summary

export const updateProductDetails = (data) => dispatch => {
    dispatch(productDataLoading())
    dispatch(productDetailsUpdated(data))
}

export const runPartNumberLookup = (catalog = null) => async (dispatch, getState) => {
    dispatch(attributeSelectionsLoading())
    // this prevents error from null categories/products
    dispatch(expandCategoriesChanged(true));
    dispatch(expandProductsChanged(true));
    dispatch(clearData())
    const state = getState();
    const partNumber = catalog ? catalog : state.configuratorStateReducer.catalogNumberLookup;
    if(partNumber.length <= 3) {
        dispatch(attemptToBuildFromCatalog());
        return;
    }
    const request = dispatch(productApi.endpoints.getProductByCatalogNumber.initiate(partNumber));
    const {data: results, isError} = await request;
    if(isError){
        dispatch(handlePartLookupError(partNumber))
        return;
    }
    // update product_attributes and sku_exceptions
    dispatch(productDataLoading())
    const productResult = dispatch(productApi.endpoints.getProduct.initiate(results.product.id));
    const {data: productResponse } = await productResult;

    // compare selections with product attributes
    let readyForSummary = true;
    const productAttributes = productResponse.product.product_attributes
    const requiredAttributesLength = productAttributes.filter(pa => !pa.optional && !pa.per_module).length
    const selections = Object.assign([], results.product.attribute_selections);
    const requiredSelectionsLength = selections.filter(as => !as.optional && !as.per_module).length;

    // if they dont match, there is missing selections so this is a partial catalog
    // set the next attribute to "" to appear for step by step
    if(requiredAttributesLength != requiredSelectionsLength){
        readyForSummary = false;
        const nextAttribute = productAttributes[selections.length];
        selections.push(Object.assign({}, nextAttribute, { selection: ''}));
    }

    dispatch(productDataReceived(productResponse.product));
    dispatch(checkForAndGetElements(results.product.id));
    dispatch(categoryIdSet(results.product_category.id));
    dispatch(shouldUpdateModulesSet(false))
    // hide product and category selections
    dispatch(setProductIdDetails(results.product.id));
    dispatch(expandCategoriesChanged(false));
    dispatch(expandProductsChanged(false));
    dispatch(separateProductAttributes(productAttributes));
    dispatch(setupSkuExceptionsAndSelections(productResponse.product));

    // update other product data and selections from results
    dispatch(updateProductDetails(results.product))
    dispatch(setProductIdDetails(results.product.id))
    dispatch(attributeSelectionsSet(selections));
    dispatch(setSelectionsFromPartNumber(results, selections))
    if(readyForSummary) {
        dispatch(setOptionalAttributes());
    }
    // dispatch(manageConfiguratorState());
    dispatch(generateCatalogNumber())
    dispatch(updateDisabledFields());

    // check for errors before summary
    const currentSelections = getState().productDataReducer.attribute_selections;
    const error = checkForEmptyRequiredSelection(currentSelections);
    if(readyForSummary && !error) {
        const summaryResponse = await dispatch(getSummary());
        dispatch(compareSummaryCatWithPartNumber(partNumber, summaryResponse.catalog_number))
        dispatch(setDisplaySummary(true));
    }

}

export const setAttributeSelections = (selections) => dispatch => {
    dispatch(attributeSelectionsLoading());
    dispatch(attributeSelectionsSet(selections));
}

export const setSideAttributeSelections = (selections) => dispatch => {
    dispatch(attributeSelectionsLoading());
    dispatch(sideAttributeSelectionsSet(selections));
}

export const setProductId = (value) => dispatch => {
    dispatch(productDataLoading())
    dispatch(productIdSet(value));
}

export const getModules = () => async (dispatch, getState) => {
    dispatch(productDataLoading());
    const state = getState();
    const catalog = state.configuratorStateReducer.catalogNumber;
    const data = await modulesApi.getModulesFromCatalog(catalog);

    const modules = normalizeModuleData(data);

    dispatch(shouldUpdateModulesSet(false));
    dispatch(setEmptyPerModuleSelections(modules))
    dispatch(setDisabledModules(modules));
    dispatch(modulesSet(modules));
    dispatch(setAttributeSelectionsFromSelections());
    dispatch(generateCatalogNumber());
    dispatch(updateDisabledFields());

}

export const normalizeModuleData = (data) => {
    const modules = [];
    // we create ids for the front end to update the correct module on selection change
    let module_id = 1;
    if(data.modules) {
        data.modules.forEach((module) => {
            // this loop will duplicate middle modules that have more than one quantity
            // we do this to remove the need for select box deciding how many options to assign per module,
            // and can use checkboxes instead to toggle a feature.
            for (let i = 0; i < module.quantity; i++) {
                // add module_id to our module
                const m = Object.assign({}, module, {
                    module_id: module_id
                })
                modules.push(m)
                // increment module id after adding it
                module_id++
            }
        })
    }
    return modules;
}

export const clearData = () => dispatch => {
    dispatch(setErrors([]));
    dispatch(setErrorFields([]));
    dispatch(clearDisabledFields());
    dispatch(setProductId(null));
    dispatch(setPatternId(null));
    dispatch(setProductIdDetails(null));
    dispatch(setPatternCode(""));
    dispatch(setDisplaySummary(false));
    dispatch(setDisplayPatternSummary(false));
    dispatch(setIsPattern(false));
    dispatch(setPatternsAvailable([]));
    dispatch(selectionsSelectionsClear());
    dispatch(attributeSelectionsClear());
    dispatch(productSelectionsClear());
    dispatch(setHasElements(false));
    dispatch(setElementsWithSelections([]));
}
export const setQuoteItemModuleAttributeSelections = (value) => dispatch => {
    dispatch(quoteItemModuleAttributeSelectionsSet(value));
}

export const loadQuoteItem = () => async(dispatch, getState) => {
    // dispatch(productDataLoading());
    const state = getState();
    const quoteId = state.projectDetailsReducer.quoteId;
    const quoteItemId = state.projectDetailsReducer.quoteItemId;
    const data = await quoteItemApi.getQuoteItem(quoteId, quoteItemId);
    if(!data){
        dispatch(selectionsSelectionsClear());
        dispatch({type: 'ADD_NOTICE', notice_type: 'catalog_number', message: 'Having Trouble Finding This Quote... Please review the URL and if everything is correct Contact Administrator'})
        $('#configurator_main').find('input, textarea, button, select').attr('disabled','disabled');
    } else {

        dispatch(setDetails(data));
        // dispatch(runPartNumberLookup(data.catalog_number));
        const catalogResult = dispatch(productApi.endpoints.getProductByCatalogNumber.initiate(data.catalog_number));
        const {data: results, isError } = await catalogResult;
        if(isError){
            dispatch(handlePartLookupError(data.catalog_number))
            return;
        }

        dispatch(categoryIdSet(results.product_category.id));
        // update product_attributes and sku_exceptions
        dispatch(productDataLoading())

        const productResult = dispatch(productApi.endpoints.getProduct.initiate(results.product.id));
        const {data: productResponse } = await catalogResult;
        dispatch(productDataReceived(productResponse.product));
        // hide product and category selections
        dispatch(setProductIdDetails(results.product.id));
        dispatch(expandCategoriesChanged(false));
        dispatch(expandProductsChanged(false));
        dispatch(separateProductAttributes(productResponse.product.product_attributes));
        dispatch(setupSkuExceptionsAndSelections(productResponse.product));

        // update other product data and selections from results
        dispatch(updateProductDetails(results.product))
        dispatch(setProductIdDetails(results.product.id))
        dispatch(attributeSelectionsSet(results.product.attribute_selections));
        dispatch(setSelectionsFromPartNumber(results))
        dispatch(setOptionalAttributes());
        await dispatch(loadQuoteItemModules());
        // dispatch(manageConfiguratorState());
        dispatch(generateCatalogNumber())
        dispatch(updateDisabledFields());
        dispatch(getSummary());
        if(data.quickship_up_to_date) {
            dispatch(setQuickshipInt(data.can_quickship))
        }

    }
}

export const setDetails = (data) => dispatch => {
    const type = data.type ? data.type : (data.group_type ? data.group_type : "")
    dispatch(setProjectType(type));
    dispatch(setQuantity(data.quantity));
    dispatch(setLineNumber(data.line_number));
}

export const loadElementQuoteItem = (copy) => async(dispatch, getState) => {
    const quoteId = getState().projectDetailsReducer.quoteId;
    const elementGroupId = getState().projectDetailsReducer.elementGroupId;
    const data = await productElementApi.getElementGroup(quoteId, elementGroupId);


    // add elements if there are any
    if(data) {
        // type quantity etc are stored on the first element currently
        dispatch(setHasElements(true));
        const mainProduct = data.product;
        dispatch(categoryIdSet(data.product_category.id));
        // update product_attributes and sku_exceptions
        dispatch(productDataLoading())
        dispatch(productDataReceived(mainProduct));
        // hide product and category selections
        dispatch(setProductIdDetails(mainProduct.id.toString()));
        dispatch(expandCategoriesChanged(false));
        dispatch(expandProductsChanged(false));
        dispatch(separateProductAttributes(mainProduct.product_attributes));
        dispatch(setupSkuExceptionsAndSelections(mainProduct));

        // update other product data and selections from results
        dispatch(updateProductDetails(mainProduct))
        dispatch(setProductIdDetails(mainProduct.id))
        dispatch(attributeSelectionsSet(mainProduct.attribute_selections));
        dispatch(setSelectionsFromPartNumber(data))
        dispatch(setOptionalAttributes());
        dispatch(generateCatalogNumber())
        dispatch(updateDisabledFields());

        let elementDetails = data.element_group;
        // on copy dont overwrite line number - its generated on configurator mount!!!
        if(copy) {
            const lineNumber = getState().projectDetailsReducer.lineNumber;
            elementDetails = Object.assign({}, elementDetails, {
                line_number: lineNumber
            })
        }

        dispatch(setDetails(elementDetails));
        // dispatch(attributeSelectionsSet(data.product))
        dispatch(productElementsSet(data.product_elements))
        dispatch(setElementsDisplayingOptions(data.elements_with_selections.map((el, i) => i)))

        // Add modules and read only attributes as they are not sent via api per #618
        let elementsWithSelectionsAndModules = fillModulesFromLoad(data.elements_with_selections, data.product_elements)
        elementsWithSelectionsAndModules = fillReadOnlyFromLoad(elementsWithSelectionsAndModules, mainProduct, data.product_elements);
        dispatch(setElementsWithSelectionsFromLoad(elementsWithSelectionsAndModules, mainProduct.product_attributes));

        // this is needed for shapes to generate sides
        const shapedAttributes = getState().productSelectionsReducer.shapedAttributes;
        if(shapedAttributes.length !== 0) {
            const generatedShapeResult = dispatch(productApi.endpoints.generateShapeElements.initiate({
                id: mainProduct.id,
                attribute_selections: mainProduct.attribute_selections
            }));
            const {data: shapeData} = await generatedShapeResult;
            if (shapeData) {
                dispatch(mapSectionsToSide(shapeData.generated_shape_elements));
                dispatch(setShapeElementsMatchSelections(true))
            }
        }
        dispatch(getElementSummary());
        dispatch(setDisplayElementSummary(true));
        dispatch(updateDisabledElementFields());
        if(data.quickship_up_to_date) {
            dispatch(setQuickshipInt(data.can_quickship))
        }
    }
}

export const loadQuoteItemModules = () => async(dispatch, getState) => {
    const state = getState();
    const quoteItemId = state.projectDetailsReducer.quoteItemId;
    const perModuleAttributes = state.productSelectionsReducer.perModuleAttributes;
    const perModuleSelections = state.productSelectionsReducer.perModuleSelections;
    let data = await modulesApi.getModulesFromQuoteId(quoteItemId);

    // handle legacy quotes without modules
    if(data.length == 0){
        const quoteItems = state.projectDetailsReducer.quoteItems;
        const quoteItem = quoteItems.find(qi => qi.id == quoteItemId);
        const catalog = quoteItem ? quoteItem.catalog_number : null;
        if(catalog){
            const response = await modulesApi.getModulesFromCatalog(catalog);
            // we add order here since we need it for selections below
            const modules = []
            if(response.modules) {
                response.modules.forEach((mod, index) => {
                    const selections = [];
                    mod.quote_item_module_options.forEach(option => {
                        const selection = option.selection == 1 ? option.module_catalog_key : ""
                        const opt = Object.assign({}, option, {
                            selection: selection
                        })
                        selections.push(opt);
                    })
                    modules.push(Object.assign({}, mod, {
                        order: ++index,
                        quote_item_module_attribute_selections: selections

                    }))
                });
            }
            data = modules;
        }
    }
    const updatedModules = []

    // go through our returned selections
    perModuleSelections.forEach(mod => {
        data.forEach(moduleAttribute => {
            // if module matches order, replace the selection with whats from the api
            if(mod.module_id == moduleAttribute.order){
                const selections = moduleAttribute.quote_item_module_attribute_selections.map(sel => sel.selection);
                updatedModules.push(Object.assign({}, mod, {selections: selections}));
            }
        })
    });

    dispatch(setPerModuleSelections(updatedModules));
    dispatch(setAttributeSelectionsFromSelections())
    dispatch(setDisplaySummary(true));
}

export const loadPatternConfiguration = () => async (dispatch, getState) => {
    const state = getState();
    const quoteId = state.projectDetailsReducer.quoteId;
    const patternEditType = state.configuratorStateReducer.patternEditType;
    let copiedQuote = false;
    let patternConfig;
    if( patternEditType == 'group') {
        const groupId = state.patternDetailsReducer.groupId;
        patternConfig = await patternApi.getPatternConfiguration(quoteId, groupId);
    } else {
        // this handles the copy feature for patterns
        copiedQuote = true;
        const quoteItemId = state.projectDetailsReducer.quoteItemId;
        patternConfig = await patternApi.getPatternConfigurationFromQuoteItem(quoteId, quoteItemId);
        // we need to clear quoteItemID after getting the config otherwise it will copy line number.
        dispatch(setQuoteItemId(""));
    }
    if(patternConfig){
        // check modules and see if we need to regenerate
        const patternModules = patternConfig.product.side_module_selections
        let modulesMissing =  false;
        const missingModuleSides = [];
        if(patternModules){
            Object.entries(patternModules).forEach(mod => {
                const sideKey = mod[0];
                if(mod[1].length == 0) {
                    modulesMissing = true;
                    missingModuleSides.push(sideKey);
                }
            })
        }

        // inject data into the store
        dispatch(setProjectName(patternConfig.projectName));
        if(!copiedQuote) {
            dispatch(setProjectType(patternConfig.type));
            dispatch(setQuantity(patternConfig.quantity));
            dispatch(setLineNumber(patternConfig.line_number));
        }

        dispatch(setProductId(patternConfig.patternId));
        dispatch(setPatternId(patternConfig.patternId));
        dispatch(setProductIdDetails(patternConfig.productFamily));
        dispatch(setIsPattern(true));
        dispatch(categoryIdSet(patternConfig.product_category.id));
        dispatch(setPatternsAvailable(patternConfig.patternsAvailable));

        // hide product and category selections
        dispatch(setProductIdDetails("pattern-" + patternConfig.patternId));
        dispatch(expandCategoriesChanged(false));
        dispatch(expandProductsChanged(false));

        dispatch(productDataLoading());
        dispatch(productDataReceived(patternConfig.product))
        dispatch(setupSkuExceptionsAndSelections(patternConfig.product));
        dispatch(setPatternCode(patternConfig.product.pattern_code))
        dispatch(separateProductAttributes(patternConfig.product.product_attributes));
        dispatch(setAttributeSelections(patternConfig.product.attribute_selections));
        // dispatch(setOptionalAttributes())
        // separate selections
        dispatch(setSelectionsFromPartNumber(patternConfig))
        dispatch(setPatternSidesFromEdit(patternConfig.product))

        // fix side selections sending?
        // dispatch(generateCatalogNumber())
        dispatch(updateDisabledFields());
        dispatch(setSideAttributeSelectionsFromSelections());
        dispatch(setSideModulesFromSelections());
        if( modulesMissing){
            missingModuleSides.forEach(side => {
                dispatch(getPatternModules(side));
            })
        }
        // show summary
        dispatch(setDisplaySummary(true));

        dispatch(updatePatternSideExceptions());
        dispatch(getPatternSummary())
        dispatch(setDisplayPatternSummary(true));
        if(patternConfig.quickship_up_to_date) {
            dispatch(setQuickshipInt(patternConfig.can_quickship))
        }

    }
}

export const setSideModules = (sideKey, modules) => (dispatch, getState) => {
    const state = getState();
    const currentSideModules = state.productDataReducer.side_modules;
    const updatedModules = [];

    // if current modules doesnt contain the side, add it
    if(!currentSideModules.find(mod => Object.keys(mod)[0] == sideKey)) {
        updatedModules.push({[sideKey] : modules});
    }

    //otherwise go through all modules and update where required

    currentSideModules.forEach((sideModules) => {
        const side = Object.keys(sideModules)[0];
        if (side == sideKey) {
            updatedModules.push({[side] : modules});
        } else {
            updatedModules.push({[side]: sideModules[side]})
        }
    })

    dispatch(productDataLoading())
    dispatch(sideModulesSet(updatedModules))
    // set module selections for the module
    const moduleSelections = [];
    modules.forEach(mod => {
        moduleSelections.push(Object.assign({}, mod, {
            selections: []
        }))
    })
    dispatch(setSideModuleSelections(sideKey, moduleSelections))
}

export const setSideModulesFromSelections = () => (dispatch, getState) => {
    const state = getState();
    const sideModuleSelections = state.productDataReducer.side_module_selections;
    const sideModules = [];
    Object.entries(sideModuleSelections).forEach(sms => {
        const side = sms[0];
        const modules = sms[1].quote_item_module_with_selections;
        sideModules.push({[side]: modules})
    })

    dispatch(productDataLoading())
    dispatch(sideModulesSet(sideModules));

}
/**
 * @description This method will attempt to build a product from catalog number. It should only be called
 * if the catalog is not valid from the api, or if the catalognumber is clearly not complete ( <4 chars length)
 * This function will go through all product attributes and attempt to find a matching selection. If all required
 * attributes are filled, then it will call summary and display it.
 * @returns {(function(*, *): Promise<void>)|*}
 */
export const attemptToBuildFromCatalog = (productResponse) => async (dispatch, getState) => {
    const state = getState();
    const products = state.productsReducer.products;
    const catalog = state.configuratorStateReducer.catalogNumberLookup;
    const familyVersionRequest = dispatch(productApi.endpoints.getFamilyVersions.initiate());
    const {data:requestData} = await familyVersionRequest;
    let productAttributes;
    let catalogNumber = catalog.toUpperCase();
    if (catalogNumber.length >= 3) {
        // length 3 suggest they may have an actual product, so try to set it
        const familyVersion = requestData.family_versions.find(vers => vers.family_version == catalogNumber.slice(0, vers.family_version.length));
        if (familyVersion) {
            const prod = products.find(prod => prod.id == familyVersion.product_id);
            await dispatch(fetchProductById(prod.id))
            dispatch(checkForAndGetElements(prod.id));
            dispatch(categoryIdSet(products.find(pd => pd.id == prod.id).product_category_id));
            dispatch(setProductData(prod.id));
            dispatch(setProductIdDetails(prod.id));
            dispatch(expandCategoriesChanged(false));
            dispatch(expandProductsChanged(false));
            let response;
            if(productResponse){
                response = productResponse;
            } else {
                const catalogResult = dispatch(productApi.endpoints.getProduct.initiate(prod.id));
                const {data} = await catalogResult;
                response = Object.assign({},data);
            }
            dispatch(productDataReceived(response.product));
            productAttributes = response.product.product_attributes;
            dispatch(setupSkuExceptionsAndSelections(response.product));
            dispatch(setDisabledFields(response.product));
            dispatch(separateProductAttributes(response.product.product_attributes));
            dispatch(setupSkuExceptionsAndSelections(response.product));
            catalogNumber = catalogNumber.split(prod.family).pop();
        } else {
            return;
        }
    }

    let noMatching = false;
    const attributeSelections = [];
    let attributeIndex = 0;
    productAttributes.forEach(pa => {
        if(catalogNumber.length == 0 || noMatching){
            return;
        }
        const values = pa.values.split(',');
        let valueFound = false;
        values.forEach(val => {
            if(valueFound) {
                return;
            }

            const substringLen = val.length;
            const catalogSubString = catalogNumber.slice(0, substringLen);
            if(val == catalogSubString){
                valueFound = true;
                attributeIndex++;
                catalogNumber = catalogNumber.substring(catalogNumber.indexOf(val) + substringLen)
                attributeSelections.push(Object.assign({}, pa, {selection: val}))
            }
        })
        if(!valueFound && !pa.optional && !pa.per_module){
            noMatching = true;
        }
    })

    dispatch(attributeSelectionsSet(attributeSelections));
    dispatch(setSelectionsFromPartNumber({
        product: {
            attribute_selections: attributeSelections
        },
        quote_item_modules: []
    }))

    if(attributeSelections.length >= productAttributes.filter(pa => !pa.optional && !pa.per_module).length) {
        dispatch(generateCatalogNumber());
        await dispatch(getModules());
        dispatch(updateDisabledFields());
        const summaryResponse = await dispatch(getSummary());
        dispatch(compareSummaryCatWithPartNumber(catalogNumber, summaryResponse.catalog_number))
        dispatch(setDisplaySummary(true));
    } else {
        dispatch(setNextSelection());
        dispatch(updateDisabledFields());
    }
}

export const addProductElementToSelections = (element) => (dispatch, getState) =>{
    const elements = getState().productDataReducer.product_element_selections;
    const updatedElements = Object.assign([], elements);
    updatedElements.push(element);
    dispatch(productElementSelectionsSet(updatedElements));
}

export const checkForAndGetElements = (id) => async (dispatch, getState) => {
    const catalogResult = dispatch(productApi.endpoints.getProductElements.initiate(id));
    const {data: response } = await catalogResult;
    if(response.product_elements.length > 0 ){
        dispatch(productElementsSet(response.product_elements));
        dispatch(setHasElements(true));
    } else {
        dispatch(setElementSaveShouldUpdate(false));
    }
}

export const handlePartLookupError = (catalogNumber) => (dispatch, getState) => {
    dispatch({type: 'ADD_NOTICE', notice_type: 'catalog_number', message: 'Invalid Catalog Number'})
    dispatch(setErrors(['Invalid Catalog Number']))
    dispatch(attributeSelectionsClear())
    dispatch(attemptToBuildFromCatalog());
}

/***
 Fills shape elements with missing module options, per module options should
 always be present under attribute selections otherwise bulk select does not
 work properly.
 ***/
export const fillModulesFromLoad = (elements, element_products) => {
    const updatedElements = [];
    for( let element of elements) {
        const elementProduct = element_products.find(e => e.id == element.id);
        const productModules = elementProduct.product_attributes.filter(pa => pa.per_module);
        for(let mod of productModules) {
            const matchingAttributeSelection = element.attribute_selections.find(as => as.id == mod.id);
            if(!matchingAttributeSelection) {
                element.attribute_selections.push(mod);
            }
        }
        updatedElements.push(element);
    }
    return updatedElements;
}

/***
 Read only on elements are not sent via api, they instead should copy parent.
 They are currently exclusively used for setting up exceptions, per #618
 ***/
export const fillReadOnlyFromLoad = (elements, parent, element_products) => {
    const updatedElements = [];
    for( let element of elements) {
        const elementProduct = element_products.find(e => e.id == element.id);
        const roAttributes = elementProduct.product_attributes.filter(pa => pa.read_only);
        for(let attr of roAttributes) {
            const matchingAttributeSelection = element.attribute_selections.find(as => as.id == attr.id);
            if(!matchingAttributeSelection) {
                const roSelection = parent.attribute_selections.find(as => as.internal_name == attr.internal_name);
                const roAttrWithSelection = Object.assign({}, attr, {selection: roSelection.selection})
                element.attribute_selections.push(roAttrWithSelection);
            }
        }
        updatedElements.push(element);
    }
    return updatedElements;
}

const reducer = productDataSlice.reducer;
export default reducer
